import styled from "styled-components";

// These could be setup to read from a design token or external constants
const primaryColor = "#F96302";
const primaryHighlight = "#FD751B";
const mainWhite = "#fff";

export const CustomButton = styled.div`
  font-family: "Open Sans", sans-serif;
  border-radius: 2px;
  height: 3rem;
  width: 9rem;
  margin: 0.5rem;
  transition: 0.3s;
  color: ${(props) => (props.type === "primary" ? mainWhite : primaryColor)};
  background-color: ${(props) =>
    props.type === "primary" ? primaryColor : "transparent"};
  border: ${(props) =>
    props.type === "tertiary" ? "none" : `2px solid ${primaryColor}`};
  &:hover {
    color: ${mainWhite};
    background-color: ${(props) =>
      props.type === "primary" ? primaryHighlight : primaryColor};
    border-color: ${(props) =>
      props.type === "primary" ? primaryHighlight : primaryColor};
  }
  @media (max-width: 768px) {
    height: 2.5rem;
    width: 7.5rem;
  }
`;
